<ul class="ver-inline-menu tabbable">
    <li [class.active]="page == 'personal-info'">
        <a class="u-cursor--pointer" [routerLink]="'/central-login/account-settings/personal-info'"><i class="fa fa-envelope"></i>
            {{ 'central-login.account.settings.personal.info' | translate }}
        </a>
    </li>
    <li [class.active]="page == 'security'" *ngIf="currentUser && !currentUser.ssoEnabled">
        <a class="u-cursor--pointer" [routerLink]="'/central-login/account-settings/security'"><i class="fa fa-lock"></i>
            {{ 'central-login.account.settings.tab.security' | translate }}
        </a>
    </li>
    <li [class.active]="page == 'preferences'">
        <a class="u-cursor--pointer" [routerLink]="'/central-login/account-settings/preferences'"><i class="fa fa-cog"></i>
            {{ 'central-login.account.settings.account.preferences' | translate }}
        </a>
    </li>
</ul>